<script setup>
await navigateTo("/");
</script>
